import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { DynamicQueryDecoratorService } from 'common/dynamicquery/dynamic-query-decorator.service';
import { LoadingModule } from 'shared/components/loading/loading.module';
import { ColumnPickerComponent } from './column-picker/column-picker.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ColumnSortByPipe } from './column-picker/pipes/column-sort-by.pipe';
import { ColumnNameFilterPipe } from './column-picker/pipes/column-name-filter.pipe';
import { TransferPanelModule } from 'shared/components/transfer-panel/transfer-panel.module';
import { QueueViewTabComponent } from './queue-view-tab.component';
import { HierarchyDropdownModule } from 'shared/components/hierarchy-dropdown/hierarchy-dropdown.module';
import { QueueViewTabService } from './queue-view-tab.service';
import { GridItemListFilterPipe } from './pipes/grid-item-list-filter.pipe';
import { GridItemValueTransformerPipe } from './pipes/grid-item-value-transformer.pipe';
import { DynamicQueryAdapterService } from 'common/dynamicquery/dynamic-query-adapter.service';
import { DatePickerModule } from 'shared/components/date-picker/date-picker.component.module';
import { TooltipModule } from 'shared/components/tooltip/tooltip.module';
import { DropdownModule } from 'shared/components/dropdown/dropdown.module';
import { WorkItemPreviewModule } from './work-item-preview/work-item-preview.module';
import { FlagModule } from 'shared/components/flag/flag.module';
import { BackendFieldConverterService } from 'shared/services/backend-field-converter/backend-field-converter.service';
import { QueueViewPermissionsService } from 'components/queue-view/queue-view-tab/queue-view-permissions.service';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { WindowSizeService } from 'common/window-size/window-size.service';
import { InfoLabelModule } from 'shared/components/info-label/info-label.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    SvgIconModule,
    FormsModule,
    LoadingModule,
    MatCheckboxModule,
    MatSelectModule,
    MatInputModule,
    TransferPanelModule,
    HierarchyDropdownModule,
    DatePickerModule,
    ReactiveFormsModule,
    TooltipModule,
    DropdownModule,
    WorkItemPreviewModule,
    FlagModule,
    ScrollingModule,
    InfoLabelModule
  ],
  providers: [
    DynamicQueryDecoratorService,
    QueueViewTabService,
    GridItemValueTransformerPipe,
    GridItemListFilterPipe,
    DynamicQueryAdapterService,
    BackendFieldConverterService,
    QueueViewPermissionsService,
    WindowSizeService
  ],
  declarations: [
    ColumnPickerComponent,
    ColumnSortByPipe,
    ColumnNameFilterPipe,
    QueueViewTabComponent,
    GridItemListFilterPipe,
    GridItemValueTransformerPipe
  ],
  exports: [
    QueueViewTabComponent
  ]
})
export class QueueViewTabModule {}
